import { z } from 'zod';
import { SanityDocumentSchema, SanitySlugSchema } from '../sanity';
import { EntityType } from '../../types';
import { PageSchema } from './Page';
import { DocumentSchema } from './Document';

export const PageTreeHierarchyItemSchema = z.object({
  _key: z.string(),
  id: z.string(),
  parent: z.string().nullish(),
  page: PageSchema.nullish(),
  file: DocumentSchema.nullish(),
  folder: z
    .object({
      name: z.string(),
      slug: SanitySlugSchema
    })
    .nullable()
    .optional()
});

export const ColorPaletteSchema = z.object({
  _key: z.string(),
  colorName: z.string(),
  hex: z.string()
});

export const PageTreeSchema = SanityDocumentSchema.extend({
  _type: z.literal(EntityType.PageTree),
  name: z.string(),
  showNavigation: z
    .boolean()
    .nullish()
    .transform((x) => x ?? true),
  hierarchy: z.object({
    hierarchyItems: z.array(PageTreeHierarchyItemSchema)
  }),
  colorPalette: z
    .object({
      colors: z.array(ColorPaletteSchema).nullish()
    })
    .optional()
    .nullable()
});

export const AllPageTreesSchema = z.array(PageTreeSchema);

export type AllPageTrees = z.infer<typeof AllPageTreesSchema>;
export type PageTree = z.infer<typeof PageTreeSchema>;
export type PageTreeHierarchyItem = z.infer<typeof PageTreeHierarchyItemSchema>;
export type ColorPalette = z.infer<typeof ColorPaletteSchema>;
